import Cookies from 'js-cookie';

const url=process.env.REACT_APP_ENV==="production"?"https://hrmanagement.zorvas.com":process.env.REACT_APP_API_URL

async function RegisterUserUsingEmail(userData)
{
    const {name,email,password,phoneNumber}=userData;
  
    try
    {
        const response=await fetch(`${url}/api/users/register`,{method:'POST',headers:{'Content-Type':"application/json"},
            body:JSON.stringify({"name":name,
                "email":email,
                "password":password,
                "phoneNumber":phoneNumber})});

         

        if(response.ok)
        {
            const data=await response.json();
            const {_id,name,email,token,phoneNumber}=data;

            // console.log(name,email,token);

            Cookies.set("id",_id,{secure:true,sameSite:'strict'});
            Cookies.set("name",name,{secure:true,sameSite:'strict'});
            Cookies.set("email",email,{secure:true,sameSite:'strict'});
            Cookies.set("token",token,{secure:true,sameSite:'strict'});
            Cookies.set("phoneNumber",phoneNumber,{secure:true,sameSite:'strict'});

            
            return data;
        }
        else
        {
            const data = await response.json();
            if (response.status === 409) {
                return data.message || "Email Id already registered!";
            } else {
                return data.message || "Something went wrong. Please try again.";
            }
        }
    }
    catch(error)
    {
        console.error("Network or unexpected error:", error);
       return "Network error. Please check your connection.";
    }
}

async function RegisterCandidate(userData)
{
    const token = Cookies.get('token'); 
    console.log('res',JSON.stringify(userData))

    try
    {
        const response=await fetch(`${url}/api/users/create-candidate-for-position`,{method:'POST',headers:{
            'Content-Type':"application/json",
            'Authorization':`Bearer ${token}`
        },
            body:JSON.stringify(userData)});

        if(response.ok)
        {
            const data=await response.json();
            const {_id,name,email,token,phoneNumber}=data;

            console.log('data',data)
            // console.log(name,email,token);

            // Cookies.set("id",_id,{secure:true,sameSite:'strict'});
            // Cookies.set("name",name,{secure:true,sameSite:'strict'});
            // Cookies.set("email",email,{secure:true,sameSite:'strict'});
            // Cookies.set("token",token,{secure:true,sameSite:'strict'});
            // Cookies.set("phoneNumber",phoneNumber,{secure:true,sameSite:'strict'});

            
            return data;
        }
        else
        {
            const data = await response.json();
            if (response.status === 409) {
                return data.message || "Email Id already registered!";
            } else {
                return data.message || "Something went wrong. Please try again.";
            }
        }
    }
    catch(error)
    {
        console.error("Network or unexpected error:", error);
       return "Network error. Please check your connection.";
    }
}

async function CheckUserProfileCompletion(userid)
{
    console.log('admin',process.env.REACT_APP_ADMIN);
    try
    {
        const response=await fetch(`${url}/api/profile/profileSetupCompleted?userid=${userid}`);
        if (!response.ok) {
            return { success: false, message: `Error ${response.status}: ${response.statusText}` };
        }
    
        return await response.json();
        
    }
    catch(error)
    {
        return { success: false, message: "A network error occurred. Please check your connection and try again." };
    }
}

async function LoginUserUsingEmail(userData) {
    const {email, password} = userData;
    try {
        const response = await fetch(`${url}/api/users/login`, {
            method: 'POST',
            headers: {'Content-Type': "application/json"},
            body: JSON.stringify({"email": email, "password": password})
        });

        if(response.ok) {
            const data = await response.json();
            console.log('akshay',data);
            const {_id, name, email, token, phoneNumber, role ,companyId } = data;
            
            //  Just set cookies, no navigation logic here
            Cookies.set("token", token, {secure: true, sameSite: 'strict'});
            Cookies.set("id", _id, {secure: true, sameSite: 'strict'});
            Cookies.set("name", name, {secure: true, sameSite: 'strict'});
            Cookies.set("email", email, {secure: true, sameSite: 'strict'});
            Cookies.set("role", role, {secure: true, sameSite: 'strict'});
            Cookies.set("companyId", companyId , {secure: true, sameSite: 'strict'});

            if(phoneNumber) {
                Cookies.set("phoneNumber", phoneNumber, {secure: true, sameSite: 'strict'});
            }

            //  Return all data including role
            return { success: true, _id, name, email, role, phoneNumber,companyId  };
        }
        else {
            const data = await response.json();
            if (response.status === 400) {
                return { success: false, message: data.message || "User not found!!" };
            } 
            else if (response.status === 401) {
                return { success: false, message: data.message || "Password not correct!!" };
            } 
            else {
                return { success: false, message: "Something went wrong. Please try again." };
            }
        }
    }
    catch(error) {
        console.error('Login error:', error);
        return { success: false, message: "A network error occurred. Please check your connection and try again." };
    }
}

async function LoginUserViaGoogle(tokenGoogle)
{
    try
    {
        const response= await fetch(`${url}/api/users/googlelogin`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: tokenGoogle }),
          });

        if(response.ok)
        {
            const data=await response.json();
            // const {_id,name,email,token,phoneNumber}=data;

            console.log(data);

            return data;
        }
        else
        {
                return "Something went wrong. Please try again.";
        }

    }
    catch(error)
    {
        return { success: false, message: "A network error occurred. Please check your connection and try again." };
    }
}

async function ForgotPasswordAuth(userData)
{
    const email=userData;

    try
    {
        const response=await fetch(`${url}/api/users/forgotpassword`,{method:'POST',headers:{'Content-Type':"application/json"},
            body:JSON.stringify({"email":email})});

        if(response.ok)
        {
            const data=await response.json();
            return data;
        }
        else
        {
            const data = await response.json();
            if (response.status === 400) {
                return data.message || "Email is required!";
            } 
            else if (response.status === 404) {
                return data.message || "User with this email ID does not exist!";
            } 
            else {
                return "Something went wrong. Please try again.",data.message;
            }
        }

    }
    catch(error)
    {
        return { success: false, message: "A network error occurred. Please check your connection and try again." };
    }
}

async function VerifyForgotPasswordToken(userData)
{
    const {token,newPassword}=userData;
    console.log(token,newPassword);

    try
    {
        const response=await fetch(`${url}/api/users/verifyresetpasswordtoken`,{method:'POST',headers:{'Content-Type':"application/json"},
            body:JSON.stringify({"token":token,"newPassword":newPassword})});

        if(response.ok)
        {
            const data=await response.json();
            return data;
        }
        else
        {
            const data = await response.json();
            if (response.status === 401) {
                return data.message || "Invalid or expired token!";
            } 
            else if (response.status === 400) {
                return data.message || "Token not found!";
            } 
            else if (response.status === 404) {
                return data.message || "User not found!";
            } 
            else {
                return "Something went wrong. Please try again.";
            }
        }

    }
    catch(error)
    {
        return { success: false, message: "A network error occurred. Please check your connection and try again." };
    }
}

async function ChangePasswordService(obj)
{
    try
    {
        const response=await fetch(`${url}/api/users/changepassword`,{headers:{'Content-Type':'application/json'},method:'POST',body:JSON.stringify(obj)});
        if(response.ok) 
            {
                const data= await response.json();
                return data;
            }
          const data=await response.json();
   
            return 'error',data.message;
    }
    catch(error)
    {
        console.log(error,'err'); 
             return error.message;
    }
}



export {RegisterCandidate, RegisterUserUsingEmail,LoginUserUsingEmail,ForgotPasswordAuth,VerifyForgotPasswordToken,LoginUserViaGoogle,CheckUserProfileCompletion,ChangePasswordService};